import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { ItemContent } from 'shared/Components/ItemContent'
import { ItemContentHandler } from 'shared/Components/ItemContent/ItemContentHandler'
import { Header } from './Header'
import { DEFAULT_THEME_COLOR } from 'shared/constants'
import { ITEM_CONTENT_ACTIONS } from 'shared/constants'
import {
  getFileMetadata, analyzeUrl, createSnapshotUrl, fetchPreviewItem
} from 'App/api/contentItems'
import isEmpty from 'lodash/isEmpty'

import './style.css.scss'

const PreviewItem = (props) => {
  const [item, setItem] = useState({})

  useEffect(() => {
    let isComponentMounted = true
    fetchPreviewItem(props.contentItemId)
      .then(item => { isComponentMounted && setItem(item) })
      .catch(props.onClose)

    return () => { isComponentMounted = false }
  }, [])

  const handleOpenInNewTab = () => {
    window.open(item.link_url, '_blank')
  }

  const itemContentActionHandler = {
    [ITEM_CONTENT_ACTIONS.createSnapshotUrl]: createSnapshotUrl,
    [ITEM_CONTENT_ACTIONS.analyzeUrl]: analyzeUrl,
    [ITEM_CONTENT_ACTIONS.getFileMetadata]: getFileMetadata
  }

  return (!isEmpty(item) &&
    <div className="preview-item-wrapper">
      <div className="preview-item">
        <Header
          title={item.name}
          item={item}
          onOpenInNewTab={handleOpenInNewTab}
          onClose={props.onClose}/>
          <ItemContentHandler itemContentActionHandler={itemContentActionHandler}>
            <ItemContent
              item={item}
              themeColorHex={DEFAULT_THEME_COLOR}
              contentItemId={item.id}
              onClick={handleOpenInNewTab}
              requireSsl={true}/>
          </ItemContentHandler>
      </div>
    </div>
  )
}

PreviewItem.propTypes = {
  contentItemId: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired
}

export default PreviewItem